import { render, staticRenderFns } from "./monthlySupplyList.vue?vue&type=template&id=6b76ce04&scoped=true"
import script from "./monthlySupplyList.vue?vue&type=script&lang=js"
export * from "./monthlySupplyList.vue?vue&type=script&lang=js"
import style0 from "./monthlySupplyList.vue?vue&type=style&index=0&id=6b76ce04&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b76ce04",
  null
  
)

export default component.exports